import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'
import { type NAVv2Filters } from '../useGetBrokersMissingPayments'

export type useGetBrokersMissingPaymentsStatisticsParams = {
  filters: NAVv2Filters
}

export type NeedsAttentionItemStatisticsResponse = {
  by_state: Record<string, number>
  by_enrollment_type: Record<string, number>
  by_reason: Record<string, number>
  by_carrier_name: Record<string, number>
}

export function getBrokersNeedsAttentionItemStatisticsQueryKey ({
  filters,
}: useGetBrokersMissingPaymentsStatisticsParams) {
  return [
    'brokers',
    'broker_attention_needed_items',
    'statistics',
    'filters',
    { ...filters },
  ]
}

export function useGetBrokersNeedsAttentionItemStatistics ({
  filters,
}: useGetBrokersMissingPaymentsStatisticsParams) {
  return useQuery<NeedsAttentionItemStatisticsResponse, GrapeAPIErrorType>({
    queryKey: getBrokersNeedsAttentionItemStatisticsQueryKey({
      filters,
    }),
    queryFn: async () => {
      const searchParams = new URLSearchParams()

      Object.entries(filters).forEach(([key, value]) => {
        if (typeof value === 'string') {
          if (value) {
            searchParams.append(`filter[${key}]`, value)
          }
        } else {
          const { include = [], exclude = [] } = value
          include.forEach((val) => {
            searchParams.append(`filter[${key}][]`, val)
          })
          exclude.forEach((val) => {
            searchParams.append(`filter[exclude_${key}][]`, val)
          })
        }
      })

      const response = await fetchWithHeaders(
        `/api/web/brokers/broker_attention_needed_items/statistics?${searchParams.toString()}`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
  })
}
